import script from "./ModalEntregaPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEntregaPedido.vue?vue&type=script&setup=true&lang=js"

import "./ModalEntregaPedido.vue?vue&type=style&index=0&id=1490fbbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1490fbbe"]])

export default __exports__